import { Avatar } from '@neshane/blueberry';
import { NavLink } from 'react-router-dom';

import { useAuth } from '../../../modules/Authentication';
import { getAvatarUrl } from '../../../modules/Profile/api/profileApi';

import './ProfileEntry.css';

export const ProfileEntry = ({ href }) => {
  const { user } = useAuth();
  const fullName = user?.getFullName?.() || '';
  const avatarUrl = getAvatarUrl(user?.avatar || '');

  if (!href) {
    return null;
  }

  return (
    <NavLink
      to={href}
      end
      className={({ isActive }) =>
        `navigation-item navigation-item-profile${isActive ? ' is-active' : ''}`
      }
    >
      <Avatar
        variant="circle"
        text={fullName}
        src={avatarUrl}
        size={24}
        className="shrink-0"
      />
      <span className="navigation-toggle-display grow">پروفایل</span>
    </NavLink>
  );
};